"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumBannerData = exports.useBanner = void 0;
const useBanner_1 = require("../hooks/useBanner");
const initializer_1 = require("../initializer");
const tracker_1 = require("../tracker");
const useBanner = (params) => (0, useBanner_1.useBanner)({ ...params, API: initializer_1.API, tracker: tracker_1.tracker });
exports.useBanner = useBanner;
var features_1 = require("../features");
Object.defineProperty(exports, "TealiumBannerData", { enumerable: true, get: function () { return features_1.TealiumBannerData; } });
//# sourceMappingURL=index.js.map